var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-icon",
  style: {
    width: "1em",
    height: "1em",
    verticalAlign: "middle",
    fill: "currentColor",
    overflow: "hidden"
  },
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M626.723881 334.476841 512 449.200722 397.275095 334.476841l-62.799278 62.799278 114.724905 114.724905L334.475817 626.723881l62.799278 62.799278 114.724905-114.724905 114.724905 114.724905 62.799278-62.799278L574.798255 512l114.724905-114.724905L626.723881 334.476841zM512 68.191078c-245.204631 0-443.808922 198.60429-443.808922 443.808922s198.60429 443.808922 443.808922 443.808922 443.808922-198.60429 443.808922-443.808922S757.203608 68.191078 512 68.191078zM512 867.046319c-195.71959 0-355.047342-159.327752-355.047342-355.047342s159.327752-355.047342 355.047342-355.047342 355.047342 159.327752 355.047342 355.047342S707.71959 867.046319 512 867.046319z"
})));
export { SvgCloseIcon as ReactComponent };
export default __webpack_public_path__ + "assets/daa62dea.svg";